<template>
  <div v-if="ownerCurrentGame && displayGame" class="levo__menu closer">
    <div class="levo__menu__gameName">{{ ownerCurrentGame.name }}</div>
    <template v-for="item in allGameTabs">
      <div
        v-if="
          gameStarted === item.gameStartedCondition &&
          (item.link === 'overview' || item.link === 'charts' ||
            (item.link === 'settings' && !isArchived()))
        "
        class="levo__menu__item"
        :key="item.link"
        :class="{ active: isItemActive(item.link) }"
        v-on:click="selectItem(item.link)"
      >
        <div class="levo__menu__item__obsah">
          <div class="levo__menu__item__obsah__text">{{ item.name }}</div>

          <div class="levo__menu__item__obsah__obrazek">
            <div :class="item.iconClass"></div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "levoMenuGame",
  data: function () {
    return {
      displayGame: true,
      archived: false,
      allGameTabs: [
        {
          name: "Game Lobby",
          iconClass: "gameSettings",
          link: "lobby",
          gameStartedCondition: false,
        },
        {
          name: "Game Settings",
          iconClass: "gameSettings",
          link: "settings",
          gameStartedCondition: true,
        },
        {
          name: "Game Overview",
          iconClass: "gameOverview-manager",
          link: "overview",
          gameStartedCondition: true,
        },
        {
          name: "Charts",
          iconClass: "gameOverview-charts",
          link: 'charts',
          gameStartedCondition: true,
        }
      ],
    };
  },
  methods: {
    selectItem: function (link) {
      this.$router.push({ name: `GameManager.game.${link}` });
    },
    isItemActive: function (link) {
      return `GameManager.game.${link}` == this.$route.name;
    },
    isArchived() {
      if (this.ownerCurrentGame.endedTime != null) {
        return true;
      } else {
        return false;
      }
    },
  },
  computed: {
    ...mapGetters(["ownerCurrentGame"]),
    gameStarted() {
      return !!this.ownerCurrentGame.startedTime;
    },
  },
  watch: {
    $route: function () {
      // Check if given route is true, if it is then hide Nav.
      if (this.$route.path === "/gameManager/allGames") {
        this.displayGame = false;
      } else {
        this.displayGame = true;
      }
    },
  },
};
</script>

